import { pxToEm } from 'util/pxToEm';
import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

export type ModalTab = 'events' | 'members' | 'about';

export interface ModalTabsProps {
  active: ModalTab;
  onChange: (tab: ModalTab) => void;
  showMembers?: boolean;
}

const TABS: Array<{ id: ModalTab; label: string }> = [
  { id: 'events', label: 'Events' },
  { id: 'members', label: 'Members' },
  { id: 'about', label: 'About' },
];

export const ModalTabs = ({
  active,
  onChange,
  showMembers = true,
}: ModalTabsProps): ReactElement => (
  <Box
    role="tablist"
    sx={{
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #F0F0F0',
      mb: 16,
      gap: 24,
    }}
  >
    {TABS.filter(tab => tab.id !== 'members' || showMembers).map(tab => {
      const isActive = tab.id === active;
      return (
        <Box
          key={tab.id}
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(tab.id)}
          sx={{
            cursor: 'pointer',
            py: 12,
            borderBottom: isActive ? '2px solid #23305F' : '2px solid transparent',
            transition: 'border-color 120ms ease',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontSize: pxToEm(14),
              fontWeight: isActive ? 600 : 400,
              color: isActive ? '#23305F' : '#383838',
              lineHeight: 1.5,
            }}
          >
            {tab.label}
          </Typography>
        </Box>
      );
    })}
  </Box>
);
